import logoMXN from '../img/logos/ike-asistencia.svg'
import logoCOL from '../img/logos/ike-komcare.svg'

export const getLogo = company =>{

    let obj = {
        1: logoMXN,
        2: logoCOL
    }

    return obj[company?.id] || logoMXN
}